import { render, staticRenderFns } from "./OverlayLoader.vue?vue&type=template&id=235c2323&scoped=true&"
import script from "./OverlayLoader.vue?vue&type=script&lang=js&"
export * from "./OverlayLoader.vue?vue&type=script&lang=js&"
import style0 from "./OverlayLoader.vue?vue&type=style&index=0&id=235c2323&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c2323",
  null
  
)

export default component.exports